import { render } from "./ViewSellers.vue?vue&type=template&id=8bd93baa&scoped=true"
import script from "./ViewSellers.vue?vue&type=script&lang=js"
export * from "./ViewSellers.vue?vue&type=script&lang=js"

import "./ViewSellers.vue?vue&type=style&index=0&id=8bd93baa&scoped=true&lang=css"
import "./ViewSellers.vue?vue&type=style&index=1&id=8bd93baa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd93baa"]])

export default __exports__